/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUpdateOrderInfo200ResponseResultsInner } from './BulkUpdateOrderInfo200ResponseResultsInner';
import {
    BulkUpdateOrderInfo200ResponseResultsInnerFromJSON,
    BulkUpdateOrderInfo200ResponseResultsInnerFromJSONTyped,
    BulkUpdateOrderInfo200ResponseResultsInnerToJSON,
    BulkUpdateOrderInfo200ResponseResultsInnerToJSONTyped,
} from './BulkUpdateOrderInfo200ResponseResultsInner';

/**
 * 
 * @export
 * @interface BulkUpdateOrderInfo200Response
 */
export interface BulkUpdateOrderInfo200Response {
    /**
     * リクエストされた注文の総数
     * @type {number}
     * @memberof BulkUpdateOrderInfo200Response
     */
    totalCount: number;
    /**
     * 更新に成功した注文の数
     * @type {number}
     * @memberof BulkUpdateOrderInfo200Response
     */
    successCount: number;
    /**
     * 更新に失敗した注文の数
     * @type {number}
     * @memberof BulkUpdateOrderInfo200Response
     */
    failureCount: number;
    /**
     * 各注文の更新結果
     * @type {Array<BulkUpdateOrderInfo200ResponseResultsInner>}
     * @memberof BulkUpdateOrderInfo200Response
     */
    results: Array<BulkUpdateOrderInfo200ResponseResultsInner>;
}

/**
 * Check if a given object implements the BulkUpdateOrderInfo200Response interface.
 */
export function instanceOfBulkUpdateOrderInfo200Response(value: object): value is BulkUpdateOrderInfo200Response {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('successCount' in value) || value['successCount'] === undefined) return false;
    if (!('failureCount' in value) || value['failureCount'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function BulkUpdateOrderInfo200ResponseFromJSON(json: any): BulkUpdateOrderInfo200Response {
    return BulkUpdateOrderInfo200ResponseFromJSONTyped(json, false);
}

export function BulkUpdateOrderInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateOrderInfo200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['total_count'],
        'successCount': json['success_count'],
        'failureCount': json['failure_count'],
        'results': ((json['results'] as Array<any>).map(BulkUpdateOrderInfo200ResponseResultsInnerFromJSON)),
    };
}

export function BulkUpdateOrderInfo200ResponseToJSON(json: any): BulkUpdateOrderInfo200Response {
    return BulkUpdateOrderInfo200ResponseToJSONTyped(json, false);
}

export function BulkUpdateOrderInfo200ResponseToJSONTyped(value?: BulkUpdateOrderInfo200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_count': value['totalCount'],
        'success_count': value['successCount'],
        'failure_count': value['failureCount'],
        'results': ((value['results'] as Array<any>).map(BulkUpdateOrderInfo200ResponseResultsInnerToJSON)),
    };
}

